import React, { Suspense } from 'react'
import {
  elementType, object, func,
} from 'prop-types'
import Loading from '@/pages/Loading'

const SusEmpty = ({
  Component, props, translate,
}) => (
  // The page's own loader while its chunk downloads: a blank page after paying read as broken (QA 2026-10-02).
  <Suspense fallback={<Loading fullscreen />}>
    {Component ? <Component {...props} t={translate} /> : null}
  </Suspense>
)

SusEmpty.propTypes = {
  Component: elementType.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  props: object,
  translate: func,
}

SusEmpty.defaultProps = {
  props: {},
  translate: () => {},
}

export default SusEmpty
